import './css.js';

// =============================================================================
// Alpine.js
// Replaces the CDN include. Must be initialised after imports.
// =============================================================================
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

// =============================================================================
// Vendor JS
// jQuery is loaded via CDN as a synchronous script before this module,
// so window.jQuery is available when this executes.
// Scripts using `this` (expecting `window`) or the CommonJS exports pattern
// are executed via new Function() which runs in sloppy mode outside the
// ES module scope.
// =============================================================================
import masonrySrc from './vendor/masonry.pkgd.js?raw';
new Function(masonrySrc)();
import imagesLoadedSrc from './vendor/imagesloaded.pkgd.js?raw';
new Function(imagesLoadedSrc)();
import './vendor/jquery.fitvids.js';
import '../vendor_pkg/owlcarousel/owl.carousel.js';
import '../vendor_pkg/fancybox/jquery.fancybox.pack.js';
import '../vendor_pkg/fancybox/helpers/jquery.fancybox-media.js';
import frescoSrc from '../vendor_pkg/fresco/fresco.js?raw';
new Function(frescoSrc)();

// =============================================================================
// Application JS
// =============================================================================
import './startup.js';

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR');
    });
}
